import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import CollectionPage from './pages/CollectionPage';
import ArtworkDetailPage from './pages/ArtworkDetailPage';
import AuthorPage from './pages/AuthorPage';
import StoriesPage from './pages/StoriesPage';
import AboutPage from './pages/AboutPage';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<CollectionPage />} />
        <Route path="stories" element={<StoriesPage />} />
        <Route path="authors" element={<AuthorPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="artwork/:slug" element={<ArtworkDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default App;
